import { Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ICustomer } from '../../../models/customer.model';
import { PATHS } from '../../../models/bary-paths.model';
import { User } from '../../../models/user.model';
import { AuthorityEnum } from '../../../models/enums/authority.enum';
import { BasketService } from '../../../services/basket.service';
import { NotificationViewDto } from '../../../models/notification-view-dto';
import { combineLatest } from 'rxjs';
import { Pagination } from '../../../models/pagination.model';
import { CurrentDataService } from '../../../services/current-data-service';
import { CurrentUserBasket } from '../../../models/current-user-basket.model';
import { FaDirectiveEnum } from '../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-nav-bar',
  templateUrl: './bary-nav-bar.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./bary-nav-bar.component.scss'],
})
export class BaryNavBarComponent implements OnInit {
  private readonly basketService = inject(BasketService);
  private readonly currentDataService = inject(CurrentDataService);

  @Input() sideClass =
    'navbar ' +
    'fixed-top ' +
    'navbar-toggleable-md ' +
    'navbar-expand-lg ' +
    'scrolling-navbar ' +
    'double-nav ' +
    // bary
    'bary-navbar ' +
    'justify-content-between ' +
    'grey-text';

  @Input() customer?: ICustomer;

  @Output() goToEvent = new EventEmitter<string>();
  @Output() logoutEvent = new EventEmitter<void>();
  @Output() toggleSideBarEvent = new EventEmitter<void>();

  protected readonly PATHS = PATHS;
  protected readonly FAS = FaDirectiveEnum.FAS;

  public basket?: CurrentUserBasket;
  public user?: User;

  public notifications!: { content: NotificationViewDto[]; pagination: Pagination };

  public ngOnInit(): void {
    combineLatest([this.currentDataService.getUser(), this.currentDataService.getCurrentBasket(), this.currentDataService.getCurrentNotifications()]).subscribe(data => {
      this.user = data[0];
      this.basket = data[1];
      this.notifications = data[2];
    });

    if (this.customer && this.hasBasket()) {
      // on force le rafraichissement.
      this.basketService.getBasket().subscribe(basket => {
        this.currentDataService.updateBasket(basket);
      });
    }
  }

  public handleGoTo(path: string): void {
    this.goToEvent.emit(path);
  }

  public handleLogout(): void {
    this.logoutEvent.emit();
  }

  public handleToggleSideBar(): void {
    this.toggleSideBarEvent.emit();
  }

  public hasBasket(): boolean {
    return ![AuthorityEnum.MODERATOR, AuthorityEnum.ADMIN].some(role => this.user?.authorities?.includes(role));
  }

  public hasNotifications(): boolean {
    return !this.user?.authorities?.includes(AuthorityEnum.ADMIN);
  }
}
